import { createConfig } from '@privy-io/wagmi';
import { http } from 'wagmi';
import { baseSepolia, base } from 'wagmi/chains';
import { env } from './utils/envs';
import { HttpTransport } from 'viem';

const transports: Record<number, HttpTransport> = {};
for (const key of Object.keys(env.VITE_WAGMI_TRANSPORTS)) {
  transports[Number(key)] = http(env.VITE_WAGMI_TRANSPORTS[key]);
}

export const config = createConfig({
  chains: env.VITE_TESTNET ? [baseSepolia] : [base],
  transports,
});
